import React, { useRef } from 'react'
import styled from 'styled-components'
import {
  useOrdersList,
  readFromLocalStorage,
  writeToLocalStorage,
} from '@sentecacommerce-theme/lib'

import { SingleItem } from './Components/SingleItem'
import DeliveryBox from './Components/DeliveryBox'
import { getHeight, setHeight } from '../../utils/heightPredictor'

export const OrderHistory = () => {
  const { data, isLoading } = useOrdersList()
  const containerRef = useRef<HTMLDivElement | null>(null)

  if (data) setHeight({ ref: containerRef, page: 'order-history' })

  if (isLoading) {
    const height = getHeight('order-history')

    return (
      <Container height={height + 'px'}>
        <DeliveryBox />
      </Container>
    )
  }

  return (
    <Container ref={containerRef} height="auto">
      <DeliveryBox />
      {data?.[0]?.results?.map((order) => {
        return <SingleItem key={order._id} data={order} />
      })}
    </Container>
  )
}

const Container = styled.div.attrs({
  className: 'd-flex flex-column align-items-center justify-content-center',
})<{ height: string }>`
  height: ${(props) => props.height};
`
